// extracted by mini-css-extract-plugin
export default {"videos":"Videos_videos__-fTTo","content":"Videos_content__RJa5L","videoWrap":"Videos_videoWrap__9W5Nd","videoTitle":"Videos_videoTitle__YJCq-","video":"Videos_video__77BbH"};